import * as styles from "./ComboboxInput.css";

import { clsx } from "clsx";
import { type JSX } from "react";

import { Combobox as BaseCombobox } from "@base-ui/react/combobox";
import { Spinner } from "@frontend/components/atoms/Spinner";

import { useComboboxContext } from "./Combobox.context";
import type { ComboboxInputProps } from "./Combobox.types";
import { ComboboxClear } from "./ComboboxClear";
import { ComboboxIcon } from "./ComboboxIcon";

export function ComboboxInput({
  className,
  showTrigger = true,
  clearable = true,
  loading = false,
  leftSection,
  rightSection,
  ...props
}: ComboboxInputProps): JSX.Element {
  const { size } = useComboboxContext();

  return (
    <BaseCombobox.InputGroup
      data-slot="combobox-input-group"
      className={styles.inputGroup({ size })}
    >
      {leftSection ? (
        <span className={styles.leftSection}>{leftSection}</span>
      ) : null}

      <BaseCombobox.Input
        data-slot="combobox-input"
        className={clsx(styles.input, className)}
        autoComplete="off"
        {...props}
      />

      {rightSection ? (
        <span className={styles.rightSection}>{rightSection}</span>
      ) : null}

      {clearable ? <ComboboxClear className={styles.clear} /> : null}

      {/* The spinner takes the chevron's place rather than sitting beside it.
          It is not rendered inside ComboboxIcon: that slot is `aria-hidden`,
          which would silence the spinner's own status role. */}
      {loading ? (
        <Spinner className={styles.spinner} />
      ) : showTrigger ? (
        <ComboboxIcon className={styles.icon} />
      ) : null}
    </BaseCombobox.InputGroup>
  );
}
